import React from 'react'
import { HorizontalStack } from '@ztechapps/webui.util'
import { BusyButton } from '@ztechapps/webui.button'

export type RefreshableTableStatProps = {
  label: string
  labelClassName?: string
  value: string
  loading: boolean
  onRefresh: () => void
  busyText: string
  className?: string
}

// A labeled stat that recomputes on click — the value is a link-styled BusyButton
// so a slow aggregate (money/token totals) can be refreshed without reloading the table.
export const RefreshableTableStat = ({
  label,
  labelClassName,
  value,
  loading,
  onRefresh,
  busyText,
  className,
}: RefreshableTableStatProps) => (
  <HorizontalStack gap={1}>
    <div className={labelClassName}>{label}</div>

    <BusyButton
      variant="link"
      isBusy={loading}
      text={value}
      onClick={() => onRefresh()}
      title="Click to refresh."
      busyText={busyText}
      className={className}
    />
  </HorizontalStack>
)
